<template>
  <div class="certification-camera">
    <div v-if="!image" class="f-center w-100b h-100b">
      <input class="upload-input" accept="image/*" required type="file" @change="uploadFile" />
      <img v-if="props.bgImage" :src="props.bgImage" :class="props.bgImageClass" />
      <img class="camera-image" :src="cameraImage" />
    </div>
    <div v-else class="f-center w-100b h-100b">
      <input class="upload-input" accept="image/*" required type="file" @change="uploadFile" />
      <img class="value-image" :src="image" alt />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue'
import { fileApi } from '@/apis'
import { Plugins, CameraResultType, CameraSource } from '@capacitor/core'
import cameraImage from '@/view/certification/assets/camera.png'
import { toast, loadingCreate } from '@/utils/alert'
import * as qiniu from '@/utils/qiniu'

export default {
  props: {
    image: String,
    bgImage: String,
    bgImageClass: String,
    fieldId: Number,
    type: {
      type: String,
      default: 'field',
    },
  },
  setup(props, { emit }) {
    const image = ref(null)

    watch(
      () => props.image,
      (v) => (image.value = v)
    )

    const fileToImg = (file) => {
      var reader = new FileReader()
      reader.onload = function (e) {
        image.value = e.target.result
      }
      reader.readAsDataURL(file)
    }

    const fileToServer = async (file) => {
      const loading = await loadingCreate('资料上传中...')
      try {
        console.log('props.fieldId ', props, props.fieldId)
        const authDicts = {
          public: async () => await fileApi.getPublicAuth(),
          field: async () => await fileApi.getFieldAuth({ id: props.fieldId }),
          private: async () => await fileApi.getPrivateAuth(),
        }
        const pubAuth = await authDicts[props.type]()
        const qiniuData = await qiniu.putbFile(
          file,
          Math.random().toString(36).slice(-16),
          pubAuth
        )
        console.log('qiniuData', qiniuData)
        const data = await fileApi.save({
          bucket: qiniuData.bucket,
          mimeType: qiniuData.mimeType,
          saveName: qiniuData.saveName,
          upName: qiniuData.upName,
          format: qiniuData.format,
        })

        return data
      } catch (error) {
        if (/limited mimeType/.test(error.data.error)) {
          toast('上传文件仅支持，jpg、png的图片格式')
        }
      } finally {
        loading.dismiss()
      }
    }

    const uploadFile = async (e) => {
      try {
        const file = e.target.files[0]
        if (file.size / 1024 / 1024 > 5.2 * 1) {
          toast('上传图片不得大于5M，重新上传')
          return
        }
        const data = await fileToServer(file)
        if (data) {
          fileToImg(file)
        }

        emit('onCaptured', { ...data, imageKey: data.saveName })
      } catch (error) {}
    }
    onMounted(() => {})
    return {
      props,
      image,
      cameraImage,
      uploadFile,
    }
  },
  components: {},
}
</script>

<style lang="scss">
.certification-camera {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  height: 308px;
  border: 2px solid #e9e9e9;
  background-color: #fff;
  border-radius: 15px;
  .upload-input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    z-index: 10;
  }
  .camera-image {
    position: absolute;
    width: 130px;
    height: 130px;
    z-index: 9;
  }
  .value-image {
    width: 100%;
    height: 100%;
  }
}
</style>